webpackJsonp(["plugin--observe-grid"],{

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__observe-grid/plugin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

var _index = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--7-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__observe-grid/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)('plugins/' + _index.PLUGIN_NAME);

function measureWidth(contextElement, cssWidth) {
	var test = document.createElement('div');
	test.style.width = cssWidth;
	contextElement.appendChild(test);
	var pixelWidth = test.offsetWidth;
	contextElement.removeChild(test);
	return pixelWidth;
}

var ObserveGrid = function ObserveGrid(element, options) {
	var _this = this;

	_classCallCheck(this, ObserveGrid);

	this.element = element;
	this.options = options;

	if (this.options.min === 0) {
		log('No minimum specified [data-observe-grid--min]. Aborting');
		return false;
	}

	if (!window.ResizeObserver) {
		log('ResizeObserver unavailable. Aborting');
		return false;
	}

	var min = this.options.min;
	var wideClass = this.options.wideClass;
	var minToPixels = measureWidth(this.element, min);

	var ro = new ResizeObserver(function (entries) {
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var entry = _step.value;

				// Get the element's current dimensions
				var rect = entry.contentRect;

				// `true` if the container is wider than the minimum
				var isWide = rect.width > minToPixels;

				// toggle the class conditionally
				_this.element.classList.toggle(wideClass, isWide);
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	});

	ro.observe(this.element);
};

ObserveGrid.DEFAULTS = {
	wideClass: 'is-above-min-width',
	min: 0
};

(0, _lib2.default)(_index.PLUGIN_NAME, ObserveGrid);

/***/ })

});


// WEBPACK FOOTER //
// scripts/plugin--observe-grid--d4572b1314bee7510215.js